import React, { useState, useRef } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import "../about/SplashPdfViewer.css";
import CTAButton from "../components/sticky-button";
import PageHeader from "../about/PageHeader";

const Downloads = () => {
  const topRef = useRef(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Updated Content List
const pdfList = [
  { 
    id: 1, 
    title: "Approved format for computation of fees for year 2026-27", 
    src: "/pdf/Footer/Downloads/Approved-format-for-computation-of-fees-for-year-2026-27.pdf", 
    isWeb: false 
  },
  { 
    id: 2, 
    title: "Audit Report F.Y. 2022 – 23", 
    src: "/pdf/Footer/Downloads/Audit-Report-Balance-sheet-F-Y-2022-23_protected.pdf", 
    isWeb: false 
  },
  { 
    id: 3, 
    title: "Audit Report F.Y. 2023 – 24", 
    src: "/pdf/Footer/Downloads/Audit-Report-Balance-sheet-F-Y-2023-24_protected.pdf", 
    isWeb: false 
  },
  { 
    id: 4, 
    title: "Audit Report F.Y. 2024 – 25", 
    src: "/pdf/Footer/Downloads/Audit-Report-balance-Sheet-FY-2024-25_protected.pdf", 
    isWeb: false 
  },
];
  const [activePdf, setActivePdf] = useState(pdfList[0]);

  const handlePdfSelection = (pdf) => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    window.scrollTo({ top: 0, behavior: "smooth" });

    if (pdf.isWeb) {
      setIsMobileMenuOpen(false);
      window.open(pdf.src, "_blank");
    } else {
      setActivePdf(pdf);
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <>
      <Navbar />
      <CTAButton />

      <div className="spv-modern-portal">
        <div ref={topRef}>
          <PageHeader 
            title="Downloads" 
            crumbs={[{ label: 'Home', href: '/' }, { label: 'Downloads' }]} 
          />
        </div>

        <div className="spv-main-content">
          {isMobileMenuOpen && (
            <button
              type="button"
              className="spv-sidebar-overlay"
              aria-label="Close documents"
              onClick={() => setIsMobileMenuOpen(false)}
            />
          )}

          <aside className={`spv-sidebar-modern ${isMobileMenuOpen ? "mobile-open" : ""}`}>
            <div className="spv-sidebar-topbar">
              <div className="spv-sidebar-header-text">FINANCIAL DOCUMENTS</div>
              <button
                type="button"
                className="spv-mobile-close"
                aria-label="Close documents"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                ×
              </button>
            </div>
           
            <nav className="spv-nav-group">
              {pdfList.map((pdf) => (
                <button
                  key={pdf.id}
                  className={`spv-nav-card ${activePdf.id === pdf.id ? "is-active" : ""}`}
                  onClick={() => handlePdfSelection(pdf)}
                >
                  <div className="spv-card-content">
                    <img 
                      src={pdf.isWeb ? "/images/icons/browser.svg" : "/images/icons/pdf.svg"} 
                      alt="icon" 
                      className="spv-doc-icon-img" 
                    />
                    <span className="spv-card-text">{pdf.title}</span>
                    <img 
                      src="/images/icons/move.webp" 
                      alt="arrow icon" 
                      className="spv-doc-icon-img" 
                    />
                  </div>
                </button>
              ))}
            </nav>
          </aside>

          <main className="spv-viewer-area">
            <header className="spv-viewer-topbar">
              <div className="spv-info-stack">
                <h2 className="spv-doc-title">{activePdf.title}</h2>
              </div>
              <div className="spv-action-group">
                <button
                  type="button"
                  className="spv-btn spv-btn-outline spv-mobile-toggle-inline"
                  onClick={() => setIsMobileMenuOpen(true)}
                >
                  Document List
                </button>
                <button className="spv-btn spv-btn-outline" onClick={() => window.open(activePdf.src)}>
                  Full Screen
                </button>
              </div>
            </header>

            <div className="spv-pdf-viewport">
              <div className="spv-pdf-card no-select">
                <iframe
                  src={`${activePdf.src}#toolbar=0&navpanes=0&scrollbar=0`}
                  className="spv-iframe-content secure-frame"
                  title="Financial Report"
                  onContextMenu={(e) => e.preventDefault()}
                />
              </div>
            </div>
          </main>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Downloads;